import React from 'react';

const KeyIcon = ({ color }: { color: string }) => {
  return (
    <svg height="22" width="22">
      <circle cx="11" cy="11" r="11" stroke="none" strokeWidth="0" fill={color} />
    </svg>
  );
};

export default KeyIcon;
